// Shrinks the canvas and clears it to assist in GC.
export const releaseCanvas = (canvas: HTMLCanvasElement): void => {
  canvas.width = 1;
  canvas.height = 1;
  const ctx = canvas.getContext("2d");
  ctx && ctx.clearRect(0, 0, 1, 1);
  canvas.parentNode?.removeChild(canvas);
};
